export default __webpack_public_path__ + "static/outside-80fa1c7c3e866f56109a7d94943d5413.png";